import { render } from "./RagTag.vue?vue&type=template&id=4b8a4d5e&scoped=true"
import script from "./RagTag.vue?vue&type=script&lang=js"
export * from "./RagTag.vue?vue&type=script&lang=js"

import "./RagTag.vue?vue&type=style&index=0&id=4b8a4d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8a4d5e"]])

export default __exports__